import React, {useState,useEffect} from 'react'
import Clients from './components/Clients'
import Footer from './components/Footer'
import Like from './components/Like'
import Release from './components/Release'
import ScrollToTop from './components/ScrollToTop'
import Signup from './components/Signup'
import SuperRare from './components/SuperRare'
import Free from './components/Free'
import Home from './components/Home'
import Navbar from './components/Navbar'
import "./scss/index.scss"
import scrollreveal from 'scrollreveal'

export default function App() {

const [theme,setTheme] = useState("dark");

const changeTheme = () => {
  theme == "dark" ? setTheme("light") : setTheme("dark");
};

useEffect(() => {
  const regsterAnimations = () => {
    const sr = scrollreveal ({
      origin: "bottom",
      distance: "80px",
      duration: 1000,
      easing: 'ease-in-out',
    });
    sr.reveal(`nav,.home,.free,.clients,.footer,.super-rare,.signup,.like,.release.orange,.release.green`,{ interval: 500 });
  };
  regsterAnimations()
});

useEffect(() => {
  const animationLeft = () => {
    const srr = scrollreveal ({
      origin: "left",
      distance: "200px",
      duration: 1000,
      easing: 'ease-in-out',
    });
    srr.reveal(`.home .content`,{ interval: 500 });
  };
  animationLeft()
  const animationRight = () => {
    const srr = scrollreveal ({
      origin: "right",
      distance: "200px",
      duration: 1000,
      reset: false,
      easing: 'ease-in-out',
    });
    srr.reveal(`.home .image-container`,{ interval: 500 });
  };
  animationRight()
});

  return (
    <div className="app-container" data-theme={theme}>
      <ScrollToTop />
      <Navbar changeTheme={changeTheme} setTheme={theme} />
      <Home />
      <Free />
      <Clients />
      <SuperRare />
      <Release />
      <Like />
      <Signup />
      <Footer />
    </div>
  )
}
